module.exports = __webpack_public_path__ + "img/church_connect_thomasroad.f9012dc9.jpg";